module.exports = __webpack_public_path__ + "static/media/14_crear_menu_plantilla_complejo_galeria_rojo.236ea8d8.jpg";